import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Inline from '../Inline';
import { NumberBox, SelectBox } from 'devextreme-react';

class CarPlate extends Component {
    constructor(props) {
        super(props);

        const cp = CarPlate.parse(this.props.value ?? '00-000/00');

        this.state = {
            left: cp.left ?? '00',
            letter: cp.letter ?? '?',
            right: cp.right ?? '000',
            iranxx: cp.iranxx ?? '00',
        }
    }
    static letters = ['ب', 'ج', 'د', 'س', 'ص', 'ط', 'ق', 'ل', 'م', 'ن', 'و', 'ه‍', 'ی', 'الف', 'ت', 'ث', 'ژ', 'ع', 'ک', '', 'گ'];

    static parse(v) {
        try {
            let [iranxx, llr] = ['00', '000?00'];
            let [part1, part2] = v.split(v.includes('ایران') ? 'ایران' : '-');

            let letter = CarPlate.letters.find(x => part2.includes(x));
            if (letter)
                [iranxx, llr] = [part1, part2];
            else {
                letter = CarPlate.letters.find(x => part1.includes(x)) ?? '';
                [iranxx, llr] = [part2, part1];
            }

            //let [iranxx, llr] = v.split(v.includes('ایران') ? 'ایران' : '-');
            //let letter = CarPlate.letters.find(x => llr.includes(x));

            let part3 = '', part4 = '';
            if (letter)
                [part3, part4] = llr.split(letter)?.map(x => x.replaceAll('/', ''));
            else
                [part3, letter, part4] = llr.split('/')?.map(x => x.replaceAll('/', ''));

            let [left, right] = part3?.length > part4?.length ? [part4, part3] : [part3, part4];
            let res = {};
            res.left = left?.trim() ?? '';
            res.letter = letter?.trim() ?? '';
            res.right = right?.trim() ?? '';
            res.iranxx = iranxx?.trim() ?? '';
            return res;
        } catch {
            return ({});
        }

    }

    getValue = () => `${this.state.left}${this.state.letter}${this.state.right}ایران${this.state.iranxx}`;

    setValue = v => {
        try {
            // let [iranxx, llr] = v.split(v.includes('ایران') ? 'ایران' : '-');
            // let letter = CarPlate.letters.find(x => llr.includes(x));
            // let left = '', right = '';
            // if (letter)
            //     [right, left] = llr.split(letter);
            // else
            //     [left, letter, right] = llr.split('/');

            let cp = CarPlate.parse(v);
            this.setState({ ...cp });
        } catch { }
    }

    componentDidMount() {
        this.setValue(this.props.value ?? '00/?/000-00');
    }

    componentDidUpdate(prevProps, prevState) {
        //this.setValue(this.props.value ?? '00/?/000-00');
    }

    render() {
        if (this.props.readOnly || this.props.readonly)
            return (
                <Inline style={{
                    direction: 'ltr', border: '1px solid black', borderRadius: '3px', background: 'blue', width: 'fit-content',
                    fontWeight: '900',
                }}>
                    <Inline style={{
                        direction: 'ltr', borderRadius: '0',
                        padding: '5px 15px', height: '-webkit-fill-available', marginLeft: '5px',
                        background: this.props.focused ? '#c7eaff' : 'white', color: 'black'
                    }}>
                        <div>
                            {this.state.left}
                        </div>
                        <div>
                            {this.state.letter}
                        </div>
                        <div>
                            {this.state.right}
                        </div>
                    </Inline>
                    <div style={{
                        direction: 'ltr', borderLeft: '1px solid black', borderRadius: '0 3px 3px 0', padding: '0 5px',
                        background: this.props.focused ? '#c7eaff' : 'white',
                        color: 'black'
                    }}>
                        <div style={{ fontSize: '0.6em' }}>ایران</div>
                        <div>{this.state.iranxx}</div>
                    </div>

                </Inline>
            );

        return (
            <Inline spacing='10px'
            >
                <NumberBox min={0} max={999}
                    value={this.state.right} onValueChanged={e => this.setState({ right: e.value }, () => this.props.onValueChanged?.(this.getValue()))}
                />
                <SelectBox items={CarPlate.letters}
                    value={this.state.letter} onValueChanged={e => this.setState({ letter: e.value }, () => this.props.onValueChanged?.(this.getValue()))}
                />
                <NumberBox min={0} max={99}
                    value={this.state.left} onValueChanged={e => this.setState({ left: e.value }, () => this.props.onValueChanged?.(this.getValue()))}
                />
                <div>ایران</div>
                <NumberBox min={10} max={99}
                    value={this.state.iranxx} onValueChanged={e => this.setState({ iranxx: e.value }, () => this.props.onValueChanged?.(this.getValue()))}
                />
            </Inline>
        );
    }
}

CarPlate.propTypes = {

};

export default CarPlate;